import React, { useMemo, useRef, useState } from "react";
import { Table, Tag, Select, DatePicker } from "antd";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import {
  formatDate,
  getCurrentFormattedDate,
} from "core/Operations/dateFormat";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { PlusCircle } from "react-feather";
import { all_routes } from "Router/all_routes";
import {
  useEmployeeAdvancePaymentList,
  usePutEmployeeAdvancePaymentList,
} from "AppQuries/loan/advance-payment";
import PaymentStatement from "Components/Modal/advance-payment/PaymentStatement";
import RepaymentModal from "Components/Modal/advance-payment/RepaymentModal";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  advancePaymentApproveValidationSchema,
  advanceRepaymentValidationSchema,
} from "core/Operations/ValidationSchema/advancePaymentValidation";
import DownloadStatement from "Components/Modal/advance-payment/DownloadStatement";
import { useReactToPrint } from "react-to-print";
import { startOfMonth, endOfMonth, format, set } from "date-fns";
import { toast } from "core/Operations/toast";
import dayjs from "dayjs";
import { useFormattedEmployees } from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import ApproveModal from "Components/Modal/approve";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
const { RangePicker } = DatePicker;
const AdvancePaymentList = () => {
  const userData = useSelector(loggedInUser);
  const [queryParams, setQueryParams] = useState({
    employeeCode: 0,
    fromDate: format(startOfMonth(new Date()), "yyyy-MM-dd"),
    toDate: format(endOfMonth(new Date()), "yyyy-MM-dd"),
  });
  const {
    data: advancePaymentList,
    advancePaymentList: isAdvancePaymentListLoading,
    isError,
    error,
    refetch: getAdvancePaymentData,
  } = useEmployeeAdvancePaymentList({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    ...queryParams,
  });
  const employeeOptions = useFormattedEmployees({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    departmentCode: 0,
  });

  const methods = useForm({
    defaultValues: {
      advancePaymentDetails: {
        companyCode: userData?.companyCode,
        createUser: userData?.userName,
        modifyUser: userData?.userName,
        modifyDate: getCurrentFormattedDate(),
        createDate: getCurrentFormattedDate(),
        showInPayslip: true,
      },
    },
    resolver: yupResolver(advanceRepaymentValidationSchema),
  });

  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [updateModalVisible, setUpdateModalVisible] = useState(false);

  const [selectedViewRecord, setSelectedViewRecord] = useState(null);
  const [selectedUpdateRecord, setSelectedUpdateRecord] = useState(null);

  const openViewModal = (record) => {
    setSelectedViewRecord(record.advancePaymentDetails);
    setViewModalVisible(true);
  };

  const openUpdateModal = (record) => {
    methods.reset({
      advancePaymentDetails: {
        slno: 0,
        code: record.code,
        employeeCode: record.employeeCode,
        companyCode: userData?.companyCode,
        createUser: userData?.userName,
        modifyUser: userData?.userName,
        modifyDate: getCurrentFormattedDate(),
        createDate: getCurrentFormattedDate(),
        showInPayslip: true,
        paidAmount: 0,
        balanceAmount: record.balanceAmount,
      },
    });
    setSelectedUpdateRecord(record);
    setUpdateModalVisible(true);
  };
  const [downloadStatementVisible, setDownloadStatementVisible] =
    useState(false);
  const [downloadStatementData, setDownloadStatementData] = useState({});

  const downloadStatementHandler = (data) => {
    setDownloadStatementData(data);
    setDownloadStatementVisible(true);
    handleTimesheetPrint();
  };
  const componentRef = useRef();
  const handleTimesheetPrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: `Advance Payment Details`,
    // onBeforePrint :
  });

  const { mutate: updateAdvancePayment, isPending } =
    usePutEmployeeAdvancePaymentList();

  const handleUpdateRepayment = (data) => {
    const { advancePaymentDetails: updatedRepaymentDetails } = data;

    const balance =
      Number(updatedRepaymentDetails.balanceAmount) -
      Number(updatedRepaymentDetails.paidAmount);

    const updatedAdvancePaymentDetails = [
      ...selectedUpdateRecord.advancePaymentDetails,

      // balanceAmount: updatedRepaymentDetails.balanceAmount - updatedRepaymentDetails.paidAmount,
      {
        ...updatedRepaymentDetails,
        balanceAmount: balance,
        installmentDate: formatDate(
          updatedRepaymentDetails.installmentDate,
          "yyyy-MM-dd"
        ),
      },
    ];

    const payload = {
      ...selectedUpdateRecord,
      paidAmount:
        Number(selectedUpdateRecord.paidAmount || 0) +
        Number(updatedRepaymentDetails.paidAmount || 0),
      balanceAmount: balance,
      advancePaymentDetails: updatedAdvancePaymentDetails,
      modifyDate: getCurrentFormattedDate(),
      modifyUser: userData?.userName,
    };

    updateAdvance(payload);
  };

  const method2 = useForm({
    defaultValues: {
      companyCode: userData?.companyCode,
      locationCode: userData?.locationCode,
      approvalDate: format(new Date(), "yyyy-MM-dd"),
      isApproved: true,
      approvedBy: userData?.userID,
    },
    resolver: yupResolver(advancePaymentApproveValidationSchema),
  });
  const [showUserList, setShowUserList] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const setShowUserListHandler = (data, status) => {
    setShowUserList(status);
    setSelectedData(data);
  };
  const manageAdvancePaymentHandler = (data) => {
    if (data) {
      const payload = {
        ...selectedData,
        approvalDate: data?.approvalDate,
        isApproved: data?.isApproved,
        approvedBy: data?.approvedBy,
        modifyDate: getCurrentFormattedDate(),
        modifyUser: userData?.userName,
      };
      updateAdvance(payload);
    }
  };

  const updateAdvance = (payload) => {
    updateAdvancePayment(payload, {
      onSuccess: ({ [0]: { response, errorMessage } }) => {
        if (response) {
          toast.success("Advance Payment Updated Successfully");
          setSelectedUpdateRecord(null);
          setUpdateModalVisible(false);
          setShowUserList(false);
          getAdvancePaymentData();
        } else {
          toast.error(errorMessage);
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueID",
      sorter: (a, b) => a.uniqueID.length - b.uniqueID.length,
    },
    {
      title: "Emp Name",
      dataIndex: "employeeName",
      fixed: "left",
      width: 250,
      render: (text, record) => (
        <Link
          to={`${all_routes.employee}${all_routes.employee_view}/${record.employeeCode}`}
          className="nowrap"
        >
          {text}
        </Link>
      ),
    },
    {
      title: "Department",
      dataIndex: "departmentName",
    },
    {
      title: "Designation",
      dataIndex: "designationName",
    },
    {
      title: "Advance Date",
      dataIndex: "advanceDate",
      render: (value) => formatDate(value, "dd-MM-yyyy"),
    },
    {
      title: "Amount",
      dataIndex: "advanceAmount",
      render: (value) => <span>{value.toFixed(2)}</span>,
    },
    { title: "Reason", dataIndex: "reason", width: 180 },
    {
      title: "Approved",
      dataIndex: "isApproved",
      render: (value) =>
        value ? <Tag color="green">Yes</Tag> : <Tag color="red">No</Tag>,
      width: 100,
    },
    { title: "Approved By", dataIndex: "approvedBy" },
    { title: "Approved Date", dataIndex: "approvalDate" },
    { title: "Repayment Start", dataIndex: "repaymentStartDate", width: 150 },
    { title: "Repayment End", dataIndex: "repaymentEndDate", width: 150 },
    {
      title: "Paid Amount",
      dataIndex: "paidAmount",
      render: (value) => <span>{value.toFixed(2)}</span>,
      width: 130,
    },
    {
      title: "Balance Amount",
      dataIndex: "balanceAmount",
      render: (value) => <span>{value.toFixed(2)}</span>,
      width: 130,
    },
    { title: "Remarks", dataIndex: "remarks", width: 180 },

    {
      title: "Action",
      dataIndex: "action",
      render: (_, record) =>
        record.isApproved ? (
          <div className="text-center">
            <Can
              accessModule={accessCodes.loan_advance}
              accessCode={accessCodes.advance_disbursement}
              accessType="haveEdit"
            >
              <Link
                className="action-set"
                to="#"
                data-bs-toggle="dropdown"
                aria-expanded="true"
              >
                <i className="fa fa-ellipsis-v" aria-hidden="true" />
              </Link>
            </Can>
            <ul className="dropdown-menu">
              <li>
                <Link
                  to={`${all_routes.advance_payment}${all_routes.advance_payment_details}/${record.code}`}
                  className="dropdown-item"
                >
                  <i data-feather="dollar-sign" className="info-img" />
                  View Loan Details
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="dropdown-item"
                  type="button"
                  onClick={() => openViewModal(record)}
                >
                  <i data-feather="dollar-sign" className="info-img" />
                  View Statement
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="dropdown-item"
                  onClick={() => openUpdateModal(record)}
                >
                  <i data-feather="plus-circle" className="info-img" />
                  Repayment
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="dropdown-item"
                  onClick={() => downloadStatementHandler(record)}
                >
                  <i data-feather="download" className="info-img" />
                  Download pdf
                </Link>
              </li>
              {/* <li>
              <Link to="#" className="dropdown-item confirm-text mb-0">
                <i data-feather="trash-2" className="info-img" />
                Delete Sale
              </Link>
            </li> */}
            </ul>
          </div>
        ) : (
          <div className="d-flex">
            <button
              className="btn btn-success"
              type="button"
              onClick={() => setShowUserListHandler(record, true)}
            >
              <i data-feather="dollar-sign" className="info-img" />
              Approve
            </button>
            {/* <button
              className="btn btn-success"
              type="button"
              onClick={() => manageAdvancePaymentHandler(record, false)}
            >
              <i data-feather="dollar-sign" className="info-img" />
              Reject
            </button> */}
          </div>
        ),
      width: 100,
    },
  ];

  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    advancePaymentList,
    searchColumns
  );

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Employee Advance Payment Details</h4>
            <h6>View and manage advance payments</h6>
          </div>
          <div className="page-btn">
            <Can
              accessModule={accessCodes.loan_advance}
              accessCode={accessCodes.advance_disbursement}
              accessType="haveAdd"
            >
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="add-new-tooltip">Add Advance Payment</Tooltip>
                }
              >
                <Link
                  to={`${all_routes.advance_payment}${all_routes.advance_payment_add}`}
                  className="btn btn-added"
                >
                  <PlusCircle className="me-2" />
                  Add Advance Payment
                </Link>
              </OverlayTrigger>
            </Can>
          </div>
        </div>
        <div className="card border-0">
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                <div className="table-list-card">
                  <TableTop
                    onSearch={setSearchValue}
                    toggleFilterVisibility={toggleFilterVisibility}
                    showToggle={true}
                    isFilterVisible={isFilterVisible}
                  />
                  <div
                    className={`card${isFilterVisible ? " visible" : ""}`}
                    id="filter_inputs"
                    // style={{ display: isFilterVisible ? "block" : "none" }}
                  >
                    <div className="card-body pb-0">
                      <div className="form-row row">
                        <div className="row">
                          <div className="col-lg-3 col-sm-6 col-12 mb-3">
                            <div className="" style={{ display: "flex" }}>
                              <div className="form-floating">
                                <RangePicker
                                  //   className="form-control"
                                  placeholder="From Date"
                                  onChange={(date, dateString) => {
                                    if (date) {
                                      updateQueryParams(
                                        "fromDate",
                                        dateString[0]
                                      );
                                      updateQueryParams(
                                        "toDate",
                                        dateString[1]
                                      );
                                    }
                                  }}
                                  defaultValue={[
                                    dayjs(queryParams?.fromDate, "YYYY-MM-DD"),
                                    dayjs(queryParams?.toDate, "YYYY-MM-DD"),
                                  ]}
                                  dateFormat="YYYY-MM-DD"
                                  className="form-control d-flex align-items-center"
                                />
                                <label className="form-label">
                                  Start Date – End Date
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-3 col-sm-6 col-12 mb-3">
                            <div className="form-floating">
                              <Select
                                className="form-control"
                                options={employeeOptions}
                                placeholder="Select Employee"
                                value={
                                  employeeOptions.find(
                                    (option) =>
                                      option.value === queryParams.employeeCode
                                  ) || ""
                                }
                                onChange={(e) => {
                                  updateQueryParams("employeeCode", e || 0);
                                }}
                                onClear={(e) => {
                                  updateQueryParams("employeeCode", 0);
                                }}
                                allowClear
                                showSearch
                                optionFilterProp="label"
                                variant="borderless"
                              />
                              <label className="form-label">Employee</label>
                            </div>
                          </div>

                          <div className="col-lg-1 col-sm-6 col-12">
                            <div className="input-blocks">
                              {/* <label className="form-label">&nbsp;</label> */}
                              <Link
                                className="btn btn-filters ms-auto"
                                onClick={getAdvancePaymentData}
                                type="button"
                              >
                                <i
                                  data-feather="search"
                                  className="feather-search"
                                />
                                <>Filter</>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <Table
                      loading={isAdvancePaymentListLoading}
                      columns={columns}
                      dataSource={filteredData}
                      rowKey="code"
                      pagination={true}
                      bordered
                      // scroll={{ x: 1500 }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* View Modal */}
        {viewModalVisible && (
          <PaymentStatement
            show={viewModalVisible}
            handleClose={() => setViewModalVisible(false)}
            record={selectedViewRecord}
          />
        )}

        {/* Update Repayment Modal */}

        <FormProvider {...methods}>
          <RepaymentModal
            show={updateModalVisible}
            handleClose={() => setUpdateModalVisible(false)}
            onSubmit={handleUpdateRepayment}
          />
        </FormProvider>
        <div style={{ display: "none" }}>
          {downloadStatementVisible && (
            <DownloadStatement
              ref={componentRef}
              data={downloadStatementData}
            />
          )}
        </div>

        <FormProvider {...method2}>
          <ApproveModal
            show={showUserList}
            locationCode={userData?.locationCode}
            companyCode={userData?.companyCode}
            handleClose={() => setShowUserList(false)}
            onSubmit={manageAdvancePaymentHandler}
          />
        </FormProvider>
      </div>
    </div>
  );
};

export default AdvancePaymentList;
